export default class AggregatorsBrand {
  static get Setsushi () { return 'sushiset' }
  static get SetDelivery () { return 'setdelivery' }
  static get WellFedElephant () { return 'well_fed_elephant' }

  static getName (enumValue) {
    switch (enumValue) {
      case AggregatorsBrand.Setsushi:
        return 'Сушисет'

      case AggregatorsBrand.SetDelivery:
        return 'СетДоставка'

      case AggregatorsBrand.WellFedElephant:
        return 'Сытый слон'

      default:
        return enumValue
    }
  }

  static getAllVariants () {
    const variants = [
      AggregatorsBrand.Setsushi,
      AggregatorsBrand.SetDelivery,
      AggregatorsBrand.WellFedElephant,
    ]

    return variants.map(item => ({
      id: item,
      value: item,
      name: AggregatorsBrand.getName(item),
    }))
  }
}
